export default __webpack_public_path__ + "static/152-min-min-6fdaf6cc6a5ae268cfe1b9c6d3225903.jpg";